import domReady from '@wordpress/dom-ready';

// toggle a class to the home header to add bg-color to navbar
const homeHeaderScroll = () => {
  let timeout;
  const navbar = document.querySelector('.navbar');
  const body = document.body;

  // Check if the page is the home template
  if (!body.classList.contains('page-template-template-home') || !navbar) {
    return; // stop here if not the home
  }

  // Apply the class on load if already scrolled
  if (window.scrollY > 49 && !navbar.classList.contains('navbar--black')) {
    navbar.classList.add('navbar--black');
  }

  // Manage the class on scroll
  window.addEventListener('scroll', function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (window.scrollY > 49 && !navbar.classList.contains('navbar--black')) {
        navbar.classList.add('navbar--black');
      } else if (
        window.scrollY < 49 &&
        navbar.classList.contains('navbar--black')
      ) {
        navbar.classList.remove('navbar--black');
      }
    }, 200);
  });
};

const homeHeaderMobileScroll = () => {
  let timeout;
  const navbar = document.querySelector('.navbar__logo.mobile');

  // Apply the class on load if already scrolled
  if (window.scrollY > 49 && !navbar.classList.contains('scroll')) {
    navbar.classList.add('scroll');
  }

  // Manage the class on scroll
  window.addEventListener('scroll', function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (window.scrollY > 49 && !navbar.classList.contains('scroll')) {
        navbar.classList.add('scroll');
      } else if (window.scrollY < 49 && navbar.classList.contains('scroll')) {
        navbar.classList.remove('scroll');
      }
    }, 200);
  });
};

domReady(() => {
  homeHeaderScroll();
  homeHeaderMobileScroll();
});
